/* Suprimal search: header overlay + predictive results. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  function qa(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function R(k, dflt) { return (window.routes && window.routes[k]) || dflt; }

  function Predictive(form) {
    if (form.__sp) return form.__sp;
    var input = form.querySelector('[data-sp-search-input]'), out = form.querySelector('[data-sp-ps-out]');
    var idle = form.querySelector('[data-sp-ps-idle]'), clear = form.querySelector('[data-sp-search-clear]');
    if (!input || !out) return null;
    var inOverlay = !!form.closest('[data-sp-search-overlay]');
    var timer, ctrl, last = '', cache = {}, active = -1;
    function items() { return qa('[data-sp-ps-item]', out); }
    function setActive(i) {
      var it = items(); active = i;
      it.forEach(function (a, k) { a.classList.toggle('is-active', k === i); a.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      if (it[i]) { input.setAttribute('aria-activedescendant', it[i].id); it[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    }
    function open(v) { out.hidden = !v; input.setAttribute('aria-expanded', v ? 'true' : 'false'); if (!v) input.removeAttribute('aria-activedescendant'); }
    function show(html) {
      out.innerHTML = html;
      items().forEach(function (a, k) { a.id = out.id + '-o' + k; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false'); });
      if (idle) idle.hidden = true;
      form.classList.add('has-results'); active = -1; open(true);
    }
    function reset() {
      out.innerHTML = ''; open(false); if (idle) idle.hidden = false;
      form.classList.remove('has-results'); active = -1;
    }
    function url(q) {
      return R('predictive_search_url', '/search/suggest') + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query,collection,page,article&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag,body' +
        '&section_id=sp-predictive-search';
    }
    function run() {
      var q = input.value.trim();
      if (clear) clear.hidden = !input.value;
      if (q.length < 2) { last = ''; if (ctrl) ctrl.abort(); form.classList.remove('is-loading'); reset(); return; }
      if (q === last && out.innerHTML) { open(true); return; }
      last = q;
      if (cache[q]) { show(cache[q]); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      form.classList.add('is-loading');
      fetch(url(q), ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) {
          var el = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-sp-ps]');
          if (!el) return;
          cache[q] = el.innerHTML;
          if (input.value.trim() === q) show(cache[q]);
        })
        .catch(function () {})
        .then(function () { if (input.value.trim() === q) form.classList.remove('is-loading'); });
    }
    input.addEventListener('input', function () { if (clear) clear.hidden = !input.value; clearTimeout(timer); timer = setTimeout(run, 170); });
    input.addEventListener('focus', function () { if (!inOverlay && input.value.trim().length > 1) run(); });
    input.addEventListener('keydown', function (e) {
      var it = items();
      if (e.key === 'Escape' && !inOverlay && !out.hidden) { e.preventDefault(); open(false); return; }
      if (out.hidden || !it.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1 >= it.length ? 0 : active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active <= 0 ? it.length - 1 : active - 1); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); it[active].click(); }
    });
    if (clear) clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; last = ''; reset(); input.focus(); });
    form.addEventListener('click', function (e) {
      var c = e.target.closest('[data-sp-q]'); if (!c) return;
      e.preventDefault(); input.value = c.getAttribute('data-sp-q'); clearTimeout(timer); run(); input.focus();
    });
    form.addEventListener('submit', function (e) { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
    if (!inOverlay) d.addEventListener('click', function (e) { if (!form.contains(e.target)) open(false); });
    form.__sp = { input: input, run: run, reset: function () { input.value = ''; if (clear) clear.hidden = true; last = ''; reset(); } };
    return form.__sp;
  }

  function initOverlay() {
    var ov = d.querySelector('[data-sp-search-overlay]');
    if (!ov || ov.__sp) return; ov.__sp = 1;
    var panel = ov.querySelector('.sp-so__panel'), p = Predictive(ov.querySelector('[data-sp-search]'));
    if (!p) return;
    var opener = null, timer;
    function open(from) {
      if (ov.classList.contains('is-open')) { p.input.focus(); return; }
      opener = from || d.activeElement; clearTimeout(timer);
      ov.hidden = false; root.classList.add('sp-search-open');
      p.input.focus({ preventScroll: true });
      ov.getBoundingClientRect(); ov.classList.add('is-open');
    }
    function close() {
      if (ov.hidden) return;
      ov.classList.remove('is-open'); root.classList.remove('sp-search-open');
      timer = setTimeout(function () { ov.hidden = true; }, 420);
      if (opener && opener.focus && d.contains(opener)) opener.focus({ preventScroll: true });
    }
    var searchPath = R('search_url', '/search');
    d.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      var t = e.target.closest('[data-sp-search-open], a[href="' + searchPath + '"]');
      if (t && !ov.contains(t)) {
        e.preventDefault();
        var pageInput = d.querySelector('.sp-srch-form [data-sp-search-input]');
        if (pageInput) { window.scrollTo({ top: 0, behavior: 'smooth' }); pageInput.focus({ preventScroll: true }); return; }
        open(t); return;
      }
      if (e.target.closest('[data-sp-search-close]')) close();
    });
    d.addEventListener('keydown', function (e) {
      if (!ov.hidden && ov.classList.contains('is-open')) {
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key === 'Tab') {
          var f = qa('a[href],button:not([disabled]),input:not([type=hidden])', panel).filter(function (x) { return x.offsetParent !== null; });
          if (!f.length) return;
          if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
        }
        return;
      }
      var tg = e.target, tag = (tg.tagName || '').toLowerCase();
      var typing = tag === 'input' || tag === 'textarea' || tag === 'select' || tg.isContentEditable;
      if ((e.key === '/' && !typing) || ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K'))) { e.preventDefault(); open(); }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { ov.classList.remove('is-open'); ov.hidden = true; root.classList.remove('sp-search-open'); } });
    window.SuprimalSearch = { open: open, close: close };
  }

  function init() {
    qa('[data-sp-search]').forEach(function (f) { if (!f.closest('[data-sp-search-overlay]')) Predictive(f); });
    initOverlay();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', init);
})();